export enum KeyCode {
	Enter = 13,
	Esc = 27,
	UpArrow = 38,
	DownArrow = 40
}
